import { frontendURL } from '../../../../helper/URLHelper';
import SalesPendingChargePage from '../pages/SalesPendingChargePage.vue';
import SalesDetailPage from '../pages/SalesDetailPage.vue';
import { salesPermissions } from './permissions';

export const salesPendingRoutes = [
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/pendencias/:installmentId'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/operacao-imobiliaria/vendas/pendencias/:salesTransactionId/:installmentId/:pendingId'
      ),
      frontendURL(
        'accounts/:accountId/vendas/pendencias/:salesTransactionId/:installmentId/:pendingId'
      ),
      frontendURL(
        'accounts/:accountId/venda/pendencias/:salesTransactionId/:installmentId/:pendingId'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_pendencia_cobranca',
    component: SalesPendingChargePage,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL('accounts/:accountId/vendas/pendencias'),
    alias: [
      frontendURL('accounts/:accountId/operacao-imobiliaria/vendas/pendencias'),
      frontendURL('accounts/:accountId/venda/pendencias'),
    ],
    redirect: to => ({
      name: 'operacao_imobiliaria_vendas',
      params: { accountId: to.params.accountId },
    }),
  },
  {
    path: frontendURL(
      'accounts/:accountId/vendas/pendencias/:salesTransactionId'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/operacao-imobiliaria/vendas/pendencias/:salesTransactionId'
      ),
      frontendURL('accounts/:accountId/venda/pendencias/:salesTransactionId'),
    ],
    redirect: to => ({
      name: 'operacao_imobiliaria_vendas',
      params: { accountId: to.params.accountId },
    }),
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/detalhes-venda'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/operacao-imobiliaria/venda/:salesTransactionId/detalhes-venda'
      ),
      frontendURL(
        'accounts/:accountId/vendas/:salesTransactionId/detalhes-venda'
      ),
      frontendURL(
        'accounts/:accountId/sales/:salesTransactionId/detalhes-venda'
      ),
      frontendURL(
        'accounts/:accountId/vendas/detalhes-venda/:salesTransactionId'
      ),
      frontendURL(
        'accounts/:accountId/venda/detalhes-venda/:salesTransactionId'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_detalhes',
    component: SalesDetailPage,
    meta: { permissions: salesPermissions },
  },
];
